export default __webpack_public_path__ + "static/media/favourite.5c7691c0.svg";